<template>
  <transition name='fade'>
    <!-- 蒙版 -->
    <div class="ej_con" v-if="show" @touchmove.prevent>
				<div class="ej_con_n">
						<div class="ej_con_n_t">
								<p>{{title}}</p>
								<img src="../../static/img/qiye/iconn19.png" @click="show = false" />
						</div>
						<div class="ej_con_n_c">{{content}}</div>
						<div class="ej_con_n_b">
								<a @click="btnClick">{{btnText}}</a>
								<span @click="show = false">取消</span>
						</div>
				</div>
				<!-- <div class="window">
					<img class="shadow" :src="imgUrl" alt="">
					<h1>{{title}}</h1>
					<p>{{content}}</p>
					<button @click="btnClick">{{btnText}}</button>
				</div>
				<text @click="show = false" v-fb class="close">关闭</text> -->
    </div>
  </transition>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      show: false,
      imgUrl: '',
      title: '',
      content: '',
      btnText: '',
      click: ''
    }
  },
  created () {
	  var that = this;
	  setTimeout(function(){
	  	//that.show = false;
	  },2000)
  },
  methods(){
	
  },
  methods: {
    btnClick () {
      this.click()
      this.show = false;
    }
  }
}
</script>
<style>
	
</style>


// WEBPACK FOOTER //
// src/components/Eject.vue